import React from 'react';
import {Checkbox, CircularProgress} from "@material-ui/core";
import axios from 'axios';
import TextField from "@material-ui/core/TextField";
import {Button} from "@material-ui/core";
import {ServiceLocator} from "../../Services/ServiceLocator";
import { v4 as uuid } from 'uuid';
import WorkshopTemplate from "./WorkshopTemplate";
import Zoom from "@material-ui/core/Zoom";
import Tooltip from "@material-ui/core/Tooltip";
import {getNumberInputDisplayValue, parseNumberInputValue} from '../../utils/numberInputUtils';
import { toUtcForStorage } from '../../utils/dateUtils';

import { AuthenticationService } from "../../Services/AuthenticationService";
let part = null;

class Inventory extends React.Component {
    state = {
        loading: true,
        savingLog: false,
        affectsSalesData: false,
        quantity: 0,
        reason: ''
    };

    constructor(props) {
        super(props);
        globalProps = props;

        const jwtToken = AuthenticationService.getInstance().getToken();
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + jwtToken;
    }

    componentDidMount() {
        this.loadData();
    }

    loadData = () => {
        const self = this;

        self.setState({loading: true});
        const partId = globalProps.match.params.partId;
        Promise.all([self.loadPart(partId)]).then(() => {
            self.setState({part, loading: false});
        });
    };

    loadPart = (partId) => {
        const partService = ServiceLocator.Instance.getPartService();

        return partService.getById(partId).then((partResult) => {
            part = partResult;
        }).catch(() => {
            part = null;
        });
    };

    addInventoryLog = () => {
        const self = this;
        const parsedQuantity = parseNumberInputValue(this.state.quantity);
        if (parsedQuantity === 0) return window.$alertWarning("You must select or enter a quantity");

        self.setState({savingLog: true});

        if (this.state.affectsSalesData === true) {
            // Quantity is an inventory delta (negative = stock out). Sales logs need a positive sold qty.
            const salesQuantity = -parsedQuantity;
            if (salesQuantity <= 0) {
                self.setState({savingLog: false});
                return window.$alertWarning("Sales projections require a stock decrease (use a negative adjustment).");
            }
            this.addSalesLog(salesQuantity);
        } else {
            const payload = {
                id: uuid(),
                quantity: parsedQuantity,
                partId: this.state.part.id,
                logDate: toUtcForStorage(new Date()),
                reason: "Manual Adjustment"
            };
            const partService = ServiceLocator.Instance.getPartService();
            partService.createInventoryLog(payload).then(() => {
                window.$alertSuccess("Inventory log created");
                self.setState({savingLog: false, completed: true});
            });
        }
    };

    addSalesLog = (parsedQuantity) => {
        const self = this;
        const payload = {
            id: uuid(),
            source: "Customer Service",
            orderNumber: "",
            logDate: toUtcForStorage(new Date()),
            assemblyId: null,
            partId: this.state.part.id,
            quantity: parsedQuantity,
            reason: `Inventory Adjustment${this.state.reason.length > 0 ? ': ' + this.state.reason : ''}`,
            userId: AuthenticationService.getInstance().getUserId(),
            affectsProjections: true,
            isManuallyAssigned: false,
            status: 'Fulfilled'
        };
        const assemblyService = ServiceLocator.Instance.getAssemblyService();
        assemblyService.importSalesLogs([payload]).then(() => {
            window.$alertSuccess("Inventory (Sales) log created");
            self.setState({savingLog: false, completed: true});
        });
    };

    render() {
        const self = this;
        if (this.state.loading) {
            return (
                <WorkshopTemplate>
                    <div className="mobile-container">
                        <CircularProgress/>
                    </div>
                </WorkshopTemplate>
            );
        }

        const {part} = self.state;

        if (this.state.completed) {
            return (
                <WorkshopTemplate>
                    <div className="mobile-container">
                        <h2>Log complete!</h2>
                        <Button onClick={() => globalProps.history.push(`/search/${part.id}`)}
                                      className="success-button-lg">Part Home</Button>
                        <br/><br/>
                    </div>
                </WorkshopTemplate>
            );
        }

        if (!part) {
            return (
                <WorkshopTemplate>
                    <div className="mobile-container">
                        <h2>Invalid URL</h2>
                    </div>
                </WorkshopTemplate>
            );
        }

        return (
            <WorkshopTemplate>
                <div className="mobile-container">
                    {part ?
                        <div>
                            <Button onClick={() => globalProps.history.push(`/search/${part.id}`)}
                                          className="success-button-lg">Part Home</Button>
                            <h2>Inventory Adjustment<br/>{part.partId} rev {part.revision}</h2>
                        </div>
                        : ""}
                    <Button label="1" primary={true}
                                  className="success-button-lg quantity-button" style={{margin: 10}}
                                  onClick={(event) => {
                                      this.setState({quantity: (parseNumberInputValue(this.state.quantity) + 1).toString()})
                                  }}>1</Button>
                    <Button label="2" primary={true}
                                  className="success-button-lg quantity-button" style={{margin: 10}}
                                  onClick={(event) => {
                                      this.setState({quantity: (parseNumberInputValue(this.state.quantity) + 2).toString()})
                                  }}>2</Button>
                    <Button label="4" primary={true}
                                  className="success-button-lg quantity-button" style={{margin: 10}}
                                  onClick={(event) => {
                                      this.setState({quantity: (parseNumberInputValue(this.state.quantity) + 4).toString()})
                                    }}>4</Button>
                    <Button label="10" primary={true}
                                  className="success-button-lg quantity-button" style={{margin: 10}}
                                  onClick={(event) => {
                                      this.setState({quantity: (parseNumberInputValue(this.state.quantity) + 10).toString()})
                                  }}>10</Button>
                    <Button label="20" primary={true}
                                  className="success-button-lg quantity-button" style={{margin: 10}}
                                  onClick={(event) => {
                                      this.setState({quantity: (parseNumberInputValue(this.state.quantity) + 20).toString()})
                                  }}>20</Button>
                    <Button label="100" primary={true}
                                  className="success-button-lg quantity-button" style={{margin: 10}}
                                  onClick={(event) => {
                                      this.setState({quantity: (parseNumberInputValue(this.state.quantity) + 100).toString()})
                                  }}>100</Button>
                    <br/><br/>
                    <Button label="-1" primary={true}
                                  className="success-button-lg quantity-button" style={{margin: 10}}
                                  onClick={(event) => {
                                      this.setState({quantity: (parseNumberInputValue(this.state.quantity) - 1).toString()})
                                  }}>-1</Button>
                    <Button label="-2" primary={true}
                                  className="success-button-lg quantity-button" style={{margin: 10}}
                                  onClick={(event) => {
                                      this.setState({quantity: (parseNumberInputValue(this.state.quantity) - 2).toString()})
                                  }}>-2</Button>
                    <Button label="-4" primary={true}
                                  className="success-button-lg quantity-button" style={{margin: 10}}
                                  onClick={(event) => {
                                      this.setState({quantity: (parseNumberInputValue(this.state.quantity) - 4).toString()})
                                  }}>-4</Button>
                    <Button label="-10" primary={true}
                                  className="success-button-lg quantity-button" style={{margin: 10}}
                                  onClick={(event) => {
                                      this.setState({quantity: (parseNumberInputValue(this.state.quantity) - 10).toString()})
                                  }}>-10</Button>
                    <Button label="-20" primary={true}
                                  className="success-button-lg quantity-button" style={{margin: 10}}
                                  onClick={(event) => {
                                      this.setState({quantity: (parseNumberInputValue(this.state.quantity) - 20).toString()})
                                  }}>-20</Button>
                    <Button label="-100" primary={true}
                                  className="success-button-lg quantity-button" style={{margin: 10}}
                                  onClick={(event) => {
                                      this.setState({quantity: (parseNumberInputValue(this.state.quantity) - 100).toString()})
                                  }}>-100</Button>
                    <br/><br/>
                    <TextField
                        placeholder="Quantity"
                        label="Quantity"
                        variant="outlined" inputProps={{inputMode: 'numeric'}}
                        onChange={(event) => this.setState({quantity: event.target.value})}
                        value={this.state.quantity || ''}
                        autoComplete="off"
                    />
                    <br/><br/>
                    <TextField
                        placeholder="Reason"
                        label="Reason"
                        variant="outlined"
                        style={{width: '100%'}}
                        onChange={(event) => this.setState({reason: event.target.value})}
                        value={this.state.reason}
                        autoComplete="off"
                    />
                    <br/><br/>
                    <Tooltip title="If selected, this will log as a sale rather than an inventory adjustment, and reflect in projections." placement="bottom" TransitionComponent={Zoom}>
                        <div>
                            <Checkbox onClick={(event) => {
                                this.setState({affectsSalesData: event.target.checked})
                            }} checked={this.state.affectsSalesData}/> Should this affect sales projections?
                        </div>
                    </Tooltip>
                    <br/><br/>
                    {this.state.savingLog === true ?
                        <CircularProgress/>
                        :
                        <Button label="Save" primary={true}
                                      className="success-button-lg"
                                      onClick={this.addInventoryLog}>Save</Button>
                    }
                    <br/><br/>
                </div>
            </WorkshopTemplate>
        );
    }
}

let globalProps;

export default Inventory;
